import { parse } from 'qs';
import reloadWindowWithParsedQueryString from './reloadWindowWithParsedQueryString';

const goToSurveyWithLang = (lang: string) => {
  // go to survey without lang query (default survey)
  const parsed = parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  parsed.lang = lang;
  // reload window
  reloadWindowWithParsedQueryString(parsed);
};

export default goToSurveyWithLang;
